import { ref } from 'vue'
import { api } from '@/api'

/**
 * 客户端组别配置映射
 */
interface ClientGroupConfigMap {
  banner_show?: string // "0" 不显示, "1" 显示
  login_mode?: string // 登录模式，逗号分隔，如 "facebook,apple,google"
  [key: string]: any
}

/**
 * API 返回的数据结构
 */
interface ClientGroupConfigResponse {
  clientGroupConfigMap: ClientGroupConfigMap
  clientGroupId: number
  clientGroupName: string
}

/**
 * 应用配置数据结构（保存到 localStorage）
 */
export interface AppConfig {
  login: string[] // 登录模式数组
  showBanner: boolean // 是否显示 Banner
}

export const appConfig = ref<AppConfig>()

/**
 * 获取应用配置
 * 从服务器获取客户端组别配置信息并保存到 localStorage
 */
export async function fetchAppConfig() {
  try {
    const { data } = await api.get<ClientGroupConfigResponse>('/client/group/getClientGroupConfig')

    // 解析配置数据
    const configMap = data.clientGroupConfigMap || {}

    // 解析登录模式：将逗号分隔的字符串转换为数组
    const loginModes = configMap.login_mode
      ? configMap.login_mode.split(',').map(mode => mode.trim()).filter(Boolean)
      : []

    // 解析 banner 显示配置：'1' 表示显示，'0' 表示不显示
    const showBanner = configMap.banner_show === '1'

    // 构建应用配置对象
    appConfig.value = {
      login: loginModes,
      showBanner,
    }

    // 将配置保存到 localStorage
    localStorage.setItem('AppConfig', JSON.stringify(appConfig.value))
  }
  catch (error) {
    console.error('Failed to fetch app config:', error)
    // 如果接口失败,使用默认配置
    appConfig.value = {
      login: [],
      showBanner: false,
    }
    localStorage.setItem('AppConfig', JSON.stringify(appConfig.value))
  }
}
